import { useState } from 'react'
import DefaultModal from '../../Utils/DefaultModal'
import { Alert, TextField, Box } from '@mui/material'
import ColorButton from '../../Buttons/ColorButton'
import { api } from '../../../services/api'
import toast from 'react-hot-toast'

const regex = /[^0-9/]+$/g

const verify_value = async (value, setVerified, setsetValue, setDiscount) => {
    const res = await api.post('/prazo_medio/', { 'cond_pag': value })
    if (res.status === 200) {
        setVerified(res.data.prazo_medio)
        setsetValue(res.data.value)
        setDiscount(res.data.discount)
        toast.success('Verificado com sucesso!')
    } else {
        setVerified('')
        setsetValue('')
        setDiscount('')
        toast.error(`Falha ao verificar: ${res.data}`)
    }
}

const SelectCustomCondpag = ({ data, handleClose, submit }) => {
    const [value, setValue] = useState('')
    const [verified, setVerified] = useState('')
    const [setvalue, setSetValue] = useState('')
    const [discount, setDiscount] = useState('')

    return (
        <DefaultModal
            open={true}
            handleClose={handleClose}
            title='Condição de pagamento customizada'
            content={
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Alert>Digite a condição de pagamento no formato: xx/yy/zz/... Onde os valores devem ser sempre incrementais, ou seja, yy sempre maior que xx.</Alert>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <TextField
                            size='small'
                            value={value}
                            onChange={({ target }) => {
                                setValue(target.value.replace(regex, ''))
                            }}
                            label='Valor'
                        />
                        <Box sx={{display:'flex', flexDirection: 'column'}}>
                            <Box><span>Valor verificado: </span><span>{setvalue}</span></Box>
                            <Box><span>Prazo Médio: </span><span>{verified}</span></Box>
                            <Box><span>Desconto/Acréscimo: </span><span>{(discount/100*-1).toFixed(2)}%</span></Box>
                        </Box>
                    </Box>
                </Box>
            }
            action={
                <>

                    <ColorButton disabled={!value} onClick={() => verify_value(value, setVerified, setSetValue, setDiscount)}>Verificar</ColorButton>
                    {verified && <ColorButton onClick={() => submit(verified, setvalue, discount)}>Salvar</ColorButton>}
                </>
            }

        />
    )
}

export default SelectCustomCondpag